import React from "react";
import "./ServicesWhyChoose.css";

const reasons = [
  {
    icon: "💎",
    title: "Jewellery Industry Focus",
    desc: "We specialize in technology solutions built exclusively for jewellery businesses.",
  },
  {
    icon: "🛠️",
    title: "100% Custom Development",
    desc: "No ready-made templates. Every solution is crafted around your business workflow.",
  },
  {
    icon: "📈",
    title: "Scalable & Secure",
    desc: "Our systems grow with your business and follow secure development practices.",
  },
  {
    icon: "🤝",
    title: "Transparent Communication",
    desc: "Clear timelines, honest updates, and zero hidden surprises.",
  },
  {
    icon: "🔧",
    title: "After-Sales Support",
    desc: "Reliable support even after project delivery.",
  },
];

const ServicesWhyChoose = () => {
  return (
    <section className="services-why">
      <div className="services-why-inner">
        <h2 className="services-why-title">Why Choose BA Code Solution?</h2>

        <div className="services-why-grid">
          {reasons.map((item, idx) => (
            <div className="services-why-item" key={idx}>
              <span className="services-why-icon">{item.icon}</span>
              <div>
                <h3 className="services-why-item-title">{item.title}</h3>
                <p className="services-why-item-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesWhyChoose;
